<div class='width-800'>

  <mat-card syyle="padding: 5px;">

    <div class='img-box'>
      <img src="assets/images/geral/sbccv_49.png">
    </div>

  </mat-card>

  <mat-card style="padding: 5px;">

    <a mat-button style='margin-right: 5px; padding: 0 9px 0 9px;  color: white;' (click)='toggleCard("0")'
      [ngStyle]="{'background-color': selectedTab === '0' ? 'rgba(216,24,34, .9)' : 'silver' }">
      <span style="padding: 0;"><b>Abertura</b></span>
    </a>

    <a mat-button style="margin-right: 5px;  padding: 0 9px 0 9px; color: white" (click)='toggleCard("1")'
      [ngStyle]="{'background-color': selectedTab === '1' ? 'rgba(216,24,34, .9)' : 'silver' }">
      <span style="padding: 0;"><b>26/05</b></span>
    </a>

    <a mat-button style='margin-right: 5px;  padding: 0 9px 0 9px; color: white;' (click)='toggleCard("2")'
      [ngStyle]="{'background-color': selectedTab === '2' ? 'rgba(216,24,34, .9)' : 'silver' }">
      <span style="padding: 0;"><b>27/05</b></span>
    </a>

    <a mat-button style=' padding: 0 9px 0 9px; color: white;' (click)='toggleCard("3")'
      [ngStyle]="{'background-color': selectedTab === '3' ? 'rgba(216,24,34, .9)' : 'silver' }">
      <span style="padding: 0px;"><b>Salas</b></span>
    </a>

  </mat-card>

  <mat-card style="padding: 5px;" *ngIf="selectedTab === '0'">

    <div
      style="padding: 5px 10px 5px 10px; margin: 10px 0 10px 0; color: white; background-color: rgb(33,142,241); font-weight: bold; border-radius: 6px;">
      <b>26/05 - 11:00</b> - ABERTURA DO 49º CONGRESSO DA SBCCV
    </div>
    <div style="margin: 5px 0px 5px 20px; color: rgba(216,24,34, .8)"><b>•Auditório Principal</b></div>
    <div style="margin: 5px 0 20px 10px;">
      <div style="padding:0 0 0 10px; color:rgb(0,66,94);">Mesa - André Raimundo Franca Guimarães </div>
      <div style="padding:0 0 0 10px; color:rgb(0,66,94);">Mesa - Pedro Rafael Salerno </div>
      <div style="padding:0 0 0 10px; color:rgb(0,66,94);">Mesa - Rui Manuel de Sousa Sequeira Antunes de Almeida </div>
      <div style="padding:0 0 0 10px; color:rgb(0,66,94);">Mesa - Vinicius José da Silva Nina</div>
      <div style="padding:0 0 0 10px; color:rgb(0,66,94);">Mesa - João Carlos Ferreira Leal </div>
      <div style="padding:0 0 0 10px; color:rgb(0,66,94);">Mesa - José Wanderley Neto </div>
      <div style="padding:0 0 0 10px; color:rgb(0,66,94);">Mesa - Eduardo Keller Saadi </div>
      <div style="padding:0 0 0 10px; color:rgb(0,66,94);">Mesa - Henrique Murad </div>
      <div style="padding:0 0 0 10px; color:rgb(0,66,94);">Mesa - Luciano Cabral Albuquerque </div>
      <div style="padding:0 0 0 10px; color:rgb(0,66,94);">Mesa - Carlos Manuel de Almeida Brandão </div>
    </div>
    <div style="margin: 0 0 20px 20px;"><b style="color:rgb(242,140,146);">11:00</b> - Palavra do Presidente ( 15 min )
      <div style="padding: 5px 0 20px 0px;">
        <div>Palestrante - João Carlos Ferreira Leal </div>
      </div>
    </div>

  </mat-card>

  <mat-card style="padding: 5px;" *ngIf="selectedTab === '1'">

    <div [innerHTML]='dataPreviewForDate_1'></div>

  </mat-card>

  <mat-card style="padding: 5px;" *ngIf="selectedTab === '2'">

    <div [innerHTML]='dataPreviewForDate_2'></div>

  </mat-card>

  <mat-card style="padding: 5px;" *ngIf="selectedTab === '3'">

    <div *ngIf="dataPreviewForLocations">

      <div *ngFor="let item of dataPreviewForLocations">

        <div class="header_1">
          {{item.location}}
        </div>

        <div *ngFor="let activity of item.activities">
          <div class="header_2">
            <b>{{ activity.date._seconds*1000 | date: 'dd/MM/yyyy' }}</b>
          </div>
          <div style="padding: 10px 0 10px 20px;">
            <b style="color: rgb(216,24,34)">{{activity.startTime}}</b> - {{activity.name}}
          </div>
          <div *ngFor="let agenda of activity.agenda">
            <div style="padding: 0 0 0 40px;">
              {{agenda.role_name}} - {{agenda.member_name}}
            </div>
          </div>

          <div *ngFor="let topic of activity.topics" style="margin-top: 10px;">
            <div style="padding: 0 0 0 60px;">
              <b style="color:rgb(242,140,146);">{{topic.startTime}}</b> - {{topic.name}}
            </div>

            <div *ngFor="let agenda of topic.agenda">
              <div style="padding: 0 0 0 80px;">
                {{agenda.role_name}} - {{agenda.member_name}}
              </div>
            </div>

          </div>

        </div>

        <hr>

      </div>

    </div>
  </mat-card>
</div>